import { createContext, useContext, useMemo, useSyncExternalStore } from 'react';
import { Post, Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { PumpFunBubblesContext } from './PumpFunBubblesContext';
import { FeedContext } from './FeedContext';
import { BonkBubblesContext } from './BonkBubblesContext';

export type LinkedCtx = React.Context<Record<number, Post | undefined>>;

export const BonkLinkedContext: LinkedCtx = createContext({});

export const PumpFunLinkedContext: LinkedCtx = createContext({});

export const BonkLinkedProvider = ({ sources, children }: React.PropsWithChildren<{ sources: Source[] }>) => {
    const feed = useContext(FeedContext);

    const [store] = useContext(BonkBubblesContext);
    const bubblesContainer = useSyncExternalStore(store.subscribe, store.get);

    const linked = useMemo(() => {
        return [...feed.Everyone, ...sources.flatMap((s) => feed[s.username])]
            .filter(Boolean)
            .filter((post) => bubblesContainer.bubbles.find((b) => b.id === post.letsBonkBubble?.id))
            .reduce((acc, post) => {
                return { ...acc, [post.letsBonkBubble!.id]: post };
            }, {} as Record<string, Post>);
    }, [bubblesContainer.bubbles, feed, sources]);

    return <BonkLinkedContext.Provider value={linked}>{children}</BonkLinkedContext.Provider>;
};

export const PumpFunLinkedProvider = ({ sources, children }: React.PropsWithChildren<{ sources: Source[] }>) => {
    const feed = useContext(FeedContext);

    const [store] = useContext(PumpFunBubblesContext);
    const bubblesContainer = useSyncExternalStore(store.subscribe, store.get);

    const linked = useMemo(() => {
        return [...feed.Everyone, ...sources.flatMap((s) => feed[s.username])]
            .filter(Boolean)
            .filter((post) => bubblesContainer.bubbles.find((b) => b.id === post.pumpFunBubble?.id))
            .reduce((acc, post) => {
                return { ...acc, [post.pumpFunBubble!.id]: post };
            }, {} as Record<string, Post>);
    }, [bubblesContainer.bubbles, feed, sources]);

    return <PumpFunLinkedContext.Provider value={linked}>{children}</PumpFunLinkedContext.Provider>;
};
